import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ClientShopsApiAdapter } from '../adapters/ClientShopsApiAdapter';

export const useClientShops = (teamId: number) => {
    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientShopsApiAdapter(httpClient);
    }, []);

    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['client-shops', teamId],
        queryFn: async () => {
            const response = await apiAdapter.getShopsByTeamId(teamId);
            return response;
        },
        staleTime: 2 * 60 * 1000,
        enabled: !!teamId,
    });

    return {
        shops: data?.data ?? [],
        total: data?.meta?.total ?? 0,
        isLoading,
        error,
        refetch,
    };
};

